export const researchRole = {
  title: "HiWi Research Assistant",
  institution: "IAS, Technische Universität Darmstadt",
  location: "Darmstadt, Germany",
  dates: "March 2025 — September 2025",
  areas: ["Computer Vision", "Machine Learning", "Robotics"],
  description:
    "Supported research activities at the intersection of computer vision, machine learning and robotics, contributing to the exploration and implementation of intelligent perception systems.",
} as const;

export const publication = {
  label: "IEEE publication",
  title: "LiDAR-Based Navigation for Dynamic and Crowded Environments",
  relationship: "Bachelor research · Middlesex University Robotics Department",
  dates: "September 2023 — April 2024",
  href: "https://ieeexplore.ieee.org/document/10892168",
  summary:
    "A measured investigation of autonomous mobile-robot navigation across changing obstacle densities, combining LiDAR, camera and ultrasonic sensing with embedded movement control.",
} as const;
